import React from 'react';
import './Reviews.scss';

import { motion } from 'framer-motion';

import { homePage } from '../../../editable-stuff/config';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';

export default function Reviews() {
  return (
    <section id='reviews' className='p-100'>
      <div className='wave-top'>
        <svg
          fill='#ffffff'
          xmlns='http://www.w3.org/2000/svg'
          viewBox='0 0 1000 300'
          preserveAspectRatio='none'
        >
          <path d='M 1000 299 l 2 -279 c -155 -36 -310 135 -415 164 c -102.64 28.35 -149 -32 -232 -31 c -80 1 -142 53 -229 80 c -65.54 20.34 -101 15 -126 11.61 v 54.39 z'></path>
          <path d='M 1000 286 l 2 -252 c -157 -43 -302 144 -405 178 c -101.11 33.38 -159 -47 -242 -46 c -80 1 -145.09 54.07 -229 87 c -65.21 25.59 -104.07 16.72 -126 10.61 v 22.39 z'></path>
          <path d='M 1000 300 l 1 -230.29 c -217 -12.71 -300.47 129.15 -404 156.29 c -103 27 -174 -30 -257 -29 c -80 1 -130.09 37.07 -214 70 c -61.23 24 -108 15.61 -126 10.61 v 22.39 z'></path>
        </svg>
      </div>
      <div className='container'>
        <div className='headers text-center mb-8'>
          <motion.h4
            initial={{ y: '100px', opacity: 0 }}
            whileInView={{ y: '0', opacity: 1 }}
            transition={{ duration: 0.5 }}
          >
            {homePage.reviwes.title}
          </motion.h4>
          <motion.h2
            className='gradient'
            initial={{ y: '100px', opacity: 0 }}
            whileInView={{ y: '0', opacity: 1 }}
            transition={{ duration: 0.5 }}
          >
            {homePage.reviwes.gradient_title}
          </motion.h2>
        </div>
        <div className='row no-gutters'>
          <div className='col-12'>
            <motion.div
              className='reviews-swiper'
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ duration: 0.5 }}
            >
              <Swiper
                spaceBetween={60}
                slidesPerView={1}
                loop={false}
                speed={1000}
                pagination={{ clickable: true }}
                modules={[Pagination]}
                breakpoints={{
                  // when window width is >= 800px
                  800: {
                    slidesPerView: 3,
                    spaceBetween: 60,
                  },
                }}
              >
                {homePage.reviwes.reviwes?.map((reviwe) => (
                  <SwiperSlide>
                    <div className='top'>
                      <div className='title'>
                        <p className='name'>{reviwe.name}</p>
                        <p className='role'>{reviwe.company}</p>
                      </div>
                      <div className='stars'>
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          viewBox='0 0 495.13 90.38'
                        >
                          <path
                            fill='url(#starGradient)'
                            d='M42.15 3.14L30.62 26.51 4.84 30.27a5.65 5.65 0 00-3.13 9.64l18.66 18.18L16 83.77a5.64 5.64 0 008.19 6l23.02-12.18 23.07 12.13a5.65 5.65 0 008.19-6l-4.41-25.63 18.66-18.18a5.65 5.65 0 00-3.13-9.64L63.8 26.51 52.28 3.14a5.66 5.66 0 00-10.13 0zM142.32 3.14L130.8 26.51 105 30.27a5.65 5.65 0 00-3.12 9.64l18.65 18.18-4.41 25.68a5.65 5.65 0 008.19 6l23.07-12.13 23.07 12.13a5.65 5.65 0 008.19-6l-4.42-25.68 18.66-18.18a5.65 5.65 0 00-3.12-9.64L164 26.51 152.45 3.14a5.66 5.66 0 00-10.13 0zM242.5 3.14L231 26.51l-25.78 3.76a5.65 5.65 0 00-3.13 9.64l18.66 18.18-4.41 25.68a5.64 5.64 0 008.19 6l23.06-12.13 23.07 12.13a5.65 5.65 0 008.19-6l-4.41-25.68 18.66-18.18a5.65 5.65 0 00-3.13-9.64l-25.78-3.76-11.56-23.37a5.66 5.66 0 00-10.13 0zM342.67 3.14l-11.52 23.37-25.79 3.76a5.65 5.65 0 00-3.12 9.64l18.65 18.18-4.41 25.68a5.65 5.65 0 008.19 6l23.07-12.13 23.07 12.13a5.65 5.65 0 008.19-6l-4.42-25.68 18.66-18.18a5.65 5.65 0 00-3.12-9.64l-25.79-3.76L352.8 3.14a5.66 5.66 0 00-10.13 0zM442.85 3.14l-11.53 23.37-25.78 3.76a5.65 5.65 0 00-3.13 9.64l18.66 18.18-4.41 25.68a5.64 5.64 0 008.19 6l23.06-12.13L471 89.72a5.65 5.65 0 008.19-6l-4.41-25.68 18.66-18.18a5.65 5.65 0 00-3.13-9.64l-25.78-3.76L453 3.14a5.66 5.66 0 00-10.13 0z'
                          ></path>
                        </svg>
                      </div>
                    </div>
                    <hr />
                    <div className='content'>
                      <p>{reviwe.content}</p>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
}
